if (!customElements.get('brekky-notify')) {
  customElements.define(
    'brekky-notify',
    class BrekkyNotify extends HTMLElement {
      connectedCallback() {
        this.wrapper = this.closest('.brekky-buy-buttons');
        this.form = this.querySelector('.brekky-notify__form');
        this.message = this.querySelector('.brekky-notify__message');
        if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));

        // Variantenwechsel: Ausverkauft-Zustand aus dem neu gerenderten Kaufen-Button lesen
        if (typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const sectionId = this.dataset.section;
            if (!event.data || event.data.sectionId !== sectionId || !event.data.html) return;
            const button = event.data.html.getElementById(`ProductSubmitButton-${sectionId}`);
            this.wrapper?.classList.toggle('is-notify', !button || button.hasAttribute('disabled'));
          });
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      async onSubmit(event) {
        event.preventDefault();
        const input = this.form.querySelector('input[type="email"]');
        const button = this.form.querySelector('button');
        const email = input.value.trim();
        if (!input.checkValidity() || !email) {
          this.showMessage('error');
          input.focus();
          return;
        }

        this.companyId = this.companyId || (await this.getCompanyId());
        if (!this.companyId) {
          this.showMessage('error');
          return;
        }

        button.setAttribute('aria-disabled', 'true');

        const variantId = document.getElementById(this.dataset.formId)?.querySelector('[name="id"]')?.value;
        const requests = [];

        if (this.dataset.listId) {
          requests.push(
            this.post('subscriptions', {
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: this.dataset.source,
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email,
                        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                      },
                    },
                  },
                },
                relationships: { list: { data: { type: 'list', id: this.dataset.listId } } },
              },
            })
          );
        }

        if (variantId) {
          requests.push(
            this.post('back-in-stock-subscriptions', {
              data: {
                type: 'back-in-stock-subscription',
                attributes: {
                  channels: ['EMAIL'],
                  profile: { data: { type: 'profile', attributes: { email } } },
                },
                relationships: {
                  variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } },
                },
              },
            })
          );
        }

        const results = await Promise.allSettled(requests);
        const ok = results.some((result) => result.status === 'fulfilled' && result.value.ok);

        button.removeAttribute('aria-disabled');

        if (ok) {
          this.form.hidden = true;
          this.showMessage('success');
        } else {
          this.showMessage('error');
        }
      }

      // Public Key kommt aus dem Klaviyo-App-Embed, das klaviyo.js?company_id=… laedt
      async getCompanyId() {
        const script = document.querySelector('script[src*="klaviyo.js?company_id="]');
        if (script) return new URL(script.src, location.href).searchParams.get('company_id');
        try {
          return await window.klaviyo?.account?.();
        } catch (error) {
          return null;
        }
      }

      post(endpoint, body) {
        return fetch(`https://a.klaviyo.com/client/${endpoint}/?company_id=${encodeURIComponent(this.companyId)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            revision: '2025-01-15',
          },
          body: JSON.stringify(body),
        });
      }

      showMessage(type) {
        const template = this.querySelector(`template[data-${type}]`);
        if (!template || !this.message) return;
        this.message.textContent = template.content.textContent.trim();
        this.message.dataset.type = type;
        this.message.hidden = false;
      }
    }
  );
}
